import React, { Component } from "react";
import PageTitle from "../../Components/PageTitle";
import axios from "axios";
import Select from 'react-select'
import { NavLink } from "react-router-dom";
import withRouter from "../../Utils/withRouter";
import { ConfigContext } from "../../Context/ConfigContext";
import Swal from 'sweetalert2';
import { SubmitButton, TextBox } from "../../Components/InputElements";
import { NoRecords } from "../../Components/Shimmer";
import TooltipComponent from "../../Components/TooltipComponent";
import { decodeData,currentDateAndTime } from "../../Constants/constants";
import ToggleSwitch from "../../Components/ToggleSwitch";


class CreatePmsTask extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);
    this.state = {
      employee_id: 0,
      reporting_manager: '1',
      location_id: "",
      department_id: "",
      rows: [],
      next: false,
      prev: false,
      page: 1,
      limit: 10,
      total_records: 0,
      total_pages: 0,
      loadingList: false,
      loadingSearch: false,
      postLoading: false,
      get_location_row: [],
      department_row: [],
      selectedEmployeeId: null,
      selectedRows: [],
      agency_verification_status: '',
      empOptions: [],
      emp_keyword: '',
      selected_rm_employee_id: '',
      reporting_manager_employee_id: '',
      goal_id: '',
      goalsModal: false,
      goal_title: "",
      errors:{},
      decodedData:[],
    };
  }
  componentDidMount() {
    this.setState({ loadingList: true }, (prevState) => {
    //   this.GetDepartmentMasters();
    //   this.GetEmployeesOptionList();
    //   this.GetLocationMasters();
      this.GetList();
    //   this.GetLocationList();
    });
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.permissions !== this.context.permissions) {
      // console.log("Permissions Updated:", this.context.permissions);
        const { permissions } = this.context;
        if (permissions.length > 0) {
          const queryParams = new URLSearchParams(window.location.search);
          const encodedData = queryParams.get("abs");
          const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
          if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
            this.setState({ decodedData });
          }
        } else {
          console.warn("Permissions not yet available. Retrying...");
        }
    }
  }
  GetEmployeesOptionList = () => {
    if (this.state.emp_keyword) {
      const { apiURL, apiHeaderJSON } = this.context;
      const headers = apiHeaderJSON;
      try {
        axios
          .get(`${apiURL}PMSRouter/GetEmployeesOptionList`, { params: { keyword: this.state.emp_keyword }, headers })
          .then((response) => {
            if (response.data.success === true) {
              this.setState({ empOptions: response.data.data })
            } else {
              this.setState({ empOptions: [] })
            }
          })
      } catch (error) {
        console.log("error", error)
      }
    } else {
      console.log("no emp keyword")
    }
  }
  handleRadioChange = (name, value) => {

    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));

  };


  GetDepartmentMasters = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}PMSRouter/GetMasters`, { headers })
      .then((response) => {
        var data = response.data.data.department;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            department_row: data.map((row) => ({
              value: row.department_id,
              label: row.department_title,
            })),
          }));
        }
      });
  };


  GetLocationMasters = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}PMSRouter/GetMasters`, { headers })
      .then((response) => {
        var data = response.data.data.location;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            Location: data.map((row) => ({
              value: row.location_id,
              label: row.location_title,
            })),
          }));
        }
      });
  };
  GetList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}PMSRouter/GetGoalsList`, {
        params: {
          limit: this.state.limit,
          page: this.state.page,
          keyword: this.state.keyword,
          from_date: this.state.from_date,
          to_date: this.state.to_date,
          department_id: this.state.department_id,
          location_id: this.state.location_id,
          reporting_manager_employee_id: this.state.reporting_manager_employee_id,
        },
        headers,
      })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState({
            rows: data.data,
            next: data.next,
            prev: data.prev,
            page: data.page,
            total_records: data.total_records,
            total_pages: data.total_pages,
            loadingList: false,
          });
        } else {
          this.setState({ loadingList: false, loadingSearch:false });
        }
      })
      .catch((error)=>{
        console.log(error);
      })
      .finally(this.setState({ loadingList: false, loadingSearch:false }));
      
  };

  handleSubmit = () => {
    // e.preventDefault()
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    const formData = {
      goal_id: this.state.goal_id || "",
      goal_title: this.state.goal_title,
      goal_description: this.state.goal_description,
      date: currentDateAndTime(),
    };
    axios.post(`${apiURL}PMSRouter/CreateGoal`, formData, { headers })
    .then((response) => {
      const { success } = response.data;
      if (success === true) {
        this.setState({ 
            goalsModal:false, loadingList: false, postLoading:false, goal_id:'', goal_title: '', goal_description:'' }, (prevState) => {
          this.GetList();
        })
        Swal.fire({ 
            title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`, 
            text: response.data.message, 
            icon: response.data.success === true ? 'success' : 'error', 
            showConfirmButton: true,
            allowOutsideClick:false, 
        });
      } else {
        Swal.fire({ title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`, 
            text: response.data.message, 
            icon: response.data.success === true ? 'success' : 'error', 
            showConfirmButton: true,
            allowOutsideClick:false, 
        });
      }
    }).catch((error)=>{
        console.log("ERROR",error);
        Swal.fire({ 
            title: `<strong>Failed</strong>`, 
            text: 'Opps...! Something went wrong.', 
            icon: 'error', 
            showConfirmButton: true,
            allowOutsideClick:false, 
        });
    }).finally(this.setState({postLoading:false}));
  };

  getInfo=(row)=>{
    this.setState({
        postLoading:false,
        goal_id: row?.goal_id,
        goal_title: row?.goal_title || "",
        goal_description: row?.goal_description || "",
        goalsModal:true,
    });
  }
    handleDelete = (goal_id) => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
    Swal.fire({
        title: 'Are you sure?',
        text: "Once deleted, you will not be able to recover this item!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, Delete!',
        cancelButtonText: 'No, cancel!',
    }).then((result) => {
        if (result.isConfirmed) {
            let data = {
                goal_id: goal_id,
            };
            // console.log("delete handle called");
            axios
                .post(`${apiURL}PMSRouter/DeleteGoal`, data, {
                    headers,
                })
                .then((response) => {
                    const { success } = response.data;
                    console.log("DeleteGoal ~ response =======>>>", response);  
                    if (success === true) {
                        Swal.fire({
                            title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                            text: response.data.message,
                            icon: success ? 'success' : 'error',
                            showConfirmButton: true,
                            allowOutsideClick: false,  // Show OK button
                        }).then((result) => {
                            if (result.isConfirmed) {
                                this.GetList();
                            }
                        });

                    } else {

                        Swal.fire({
                            title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                            text: response.data.message,
                            icon: success ? 'success' : 'error',
                            showConfirmButton: true,
                            allowOutsideClick: false,  // Show OK button
                        }).then((result) => {
                            if (result.isConfirmed) {

                            }
                        });

                    }
                });
        }
        // else {
        //     Swal.fire({
        //         title: 'Cancelled',
        //         text: 'Cancelled Delete..',
        //         icon: 'info',
        //         timer: 1500,
        //         showConfirmButton: false
        //     });
        //     return; // Do nothing if the user cancels
        // }
    });

}
    handleToggleSwitch = (goal_id, toggleButton) => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
    Swal.fire({
        title: 'Are you sure?',
        text: `Do you want to change head status to ${toggleButton ? "On" : "Off"}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes!',
        cancelButtonText: 'No!',
    }).then((result) => {
        if (result.isConfirmed) {
            let data = {
                goal_id: goal_id,
                activated: toggleButton ? "1" : "0",
            }
            console.log(data);
            axios
                .post(`${apiURL}PMSRouter/HandleGoalAction`, data, {
                    headers,
                })
                .then((response) => {
                    const { success } = response.data;
                    console.log("HandleGoalAction ~ response =======>>>", response);
                    if (success === true) {
                        Swal.fire({ title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`, 
                            text: response.data.message, 
                            icon: response.data.success === true ? 'success' : 'error', 
                            showConfirmButton: true,
                            allowOutsideClick:false, 
                        });
                        this.GetList();
                    } else {
                        Swal.fire({ title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`, 
                            text: response.data.message, 
                            icon: response.data.success === true ? 'success' : 'error', 
                            showConfirmButton: true,
                            allowOutsideClick:false, 
                        });
                    }
                });
        }
        // else {
        //     Swal.fire({
        //         title: 'Cancelled',
        //         text: 'Cancelled..',
        //         icon: 'info',
        //         timer: 1500,
        //         showConfirmButton: false
        //     });
        //     return; // Do nothing if the user cancels
        // }
    });

}

  handleInputSearch = (e) => {
    this.GetList();
    //   this.GetLocationList();
  }

  handleInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    },()=>{
        if(!e.target.value){
            this.GetList();
        }
    })
  };


  handleCheckboxChange = (employeeId) => {
    this.setState((prevState) => {
      const selectedRows = [...prevState.selectedRows];

      if (selectedRows.includes(employeeId)) {
        selectedRows.splice(selectedRows.indexOf(employeeId), 1);
      } else {
        selectedRows.push(employeeId);
      }

      return { selectedRows };
    });
  };

  handleSelectAll = () => {
    this.setState((prevState) => {
      const selectedRows = prevState.selectedRows.length === prevState.rows.length
        ? []
        : prevState.rows.map((row) => row.employee_id);

      return { selectedRows };
    });
  };

  handleSelectAllDropdown = (action) => {
    if (action === 'select-all') {
      this.setState({ selectedRows: this.state.rows.map((row) => row.employee_id) });
    } else if (action === 'deselect-all') {
      this.setState({ selectedRows: [] });
    }
  };

  GetLocationList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}Masters/GetLocationList`, { headers })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            get_location_row: data.data.map((row) => ({
              value: row.location_id,
              label: row.location_title
            }))
          }));
        }
      });
  }

  handlePrev = (ev) => {
    if (this.state.prev === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page - 1 };
        },
        () => {
            if(this.state.rows?.length>0){
                this.GetList();
            }
        }
      );
    }
  };
  handleNext = () => {
    if (this.state.next === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page + 1 };
        },
        () => {
            if(this.state.rows?.length>0){
                this.GetList();
            }
        }
      );
    }
  };
  handleChange = (e) => {
    this.setState(
      (prevState) => {
        return { page: parseInt(e.target.value, 10) };
      },
      () => {
        if(this.state.rows?.length>0){
            this.GetList();
        }
      }
    );
  };

  handleSelectChange = (name, selectedOption) => {

    this.setState((prevState) => ({
      [name]: selectedOption.value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };
  handleLimitChange = (e) => {
    this.setState(
      {
        limit: parseInt(e.target.value, 10),
        page: 1, // Reset to first page
      },
      () => {
        if(this.state.rows?.length>0){
            this.GetList();
        }
      }
    );
  };
  handleClearAll = () => {
    this.setState(
      {
        location_id: '',
        department_id: '',
        location_shift_id: '',
        reporting_manager_employee_id: '',
        keyword: "",
        rows: [],
        next: false,
        prev: false,
        page: 1,
        limit: 10,
        total_records: 0,
        total_pages: 0,
        loadingList: false,
        postLoading: false,
      },
      () => {
        this.GetList();
      }
    );
  };

  render() {
    const limitOptions = [10, 25, 50, 100, 200, 500,];

    return (
        <>
        {!this.state.loadingList?
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <br />
                        <PageTitle title={`Goals`} primary={`Home`} />
                        <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                            <div className="card-header">
                                <div className="row d-flex justify-content-between align-items-center">
                                <div className='col-md-3'>
                                    <label htmlFor="keyword">Search By Title</label>
                                    <div className="input-group">
                                    <input type="search" className="form-control" onChange={this.handleInputChange} name="keyword" value={this.state.keyword}  aria-describedby="button-addon2" placeholder="Enter Title" />
                                    <TooltipComponent name="Search" position="bottom">
                                        <button className="btn btn-success" 
                                     onClick={() => { if ( this.state.keyword && !this.state.loadingSearch ) {this.setState({ loadingSearch:true },()=>{ this.handleInputSearch(); }) } }}
                                    type="button" id="button-addon2">
                                    {this.state.loadingSearch ? (
                                        <span class="spinner-border flex-shrink-0" role="status" style={{ width: "0.8rem", height: "0.8rem", borderWidth: "2px", }}>
                                            <span class="visually-hidden">Loading...</span>
                                        </span>
                                        ) : (
                                        <i className="ri-search-line"></i>
                                        )}
                                        </button>
                                    </TooltipComponent>
                                    </div>
                                </div>

                                {/* <div className="col-md-3 ">
                                    <label htmlFor="Employee" className="form-label" > Search & Select Reporting Manager </label>
                                    <Select
                                    onInputChange={(e) => this.setState({ emp_keyword: e }, () => { this.GetEmployeesOptionList() })}
                                    options={this.state.empOptions}
                                    onChange = {(selectedOption) => this.handleSelectChange('reporting_manager_employee_id', selectedOption)}
                                    placeholder={`Enter Reporting Manager Code Or Name`}
                                    />
                                </div> */}

                                {/* search employees under selected reporting manager */}
                                {/* <div className='col-md-3'>
                                    <div>
                                    <label>Search & Select Reporting Manager</label>
                                    </div>
                                    <Select
                                    options = {this.state.empOptions}
                                    value = {this.state.reporting_manager_employee_id ? this.state.empOptions.find(option => option.value === this.state.reporting_manager_employee_id) : null}
                                    onChange = {(selectedOption) => this.handleSelectChange('reporting_manager_employee_id', selectedOption)}
                                    placeholder={`Select Reporting Manager`}
                                    />
                                </div> */}
                                {/* search employees under selected reporting manager */}

                                {/* <div className='col-md-3'>
                                    <div>
                                    <label>Location</label>
                                    </div>
                                    <Select
                                    options={this.state.get_location_row}
                                    value={this.state.location_id ? this.state.get_location_row.find(option => option.value === this.state.location_id) : null}
                                    onChange={(selectedOption) => this.handleSelectChange('location_id', selectedOption)}
                                    placeholder={`Select Location`}
                                    />

                                </div> */}
                                {/* <div className='col-md-3'>
                                    <div>
                                    <label>Department</label>
                                    </div>
                                    <Select
                                    onChange={(selectedOption) => this.handleSelectChange('department_id', selectedOption)}
                                    placeholder={`Select Department`}
                                    options={this.state.department_row}
                                    value={this.state.department_id ? this.state.department_row.find((option) => option.value === this.state.department_id) : null}
                                    />
                                </div> */}
                                {/* <div className="row mt-3"> */}
                                    {/* <div className='col-md-3'>
                                    <div className="row">
                                        <div className='col-md-6'>
                                        <div>
                                            <label>Apply Filter</label>
                                        </div>
                                        <button
                                            type="button"
                                            onClick={this.handleInputSearch}
                                            disabled={!this.state.location_id && !this.state.department_id && !this.state.location_shift_id && !this.state.reporting_manager_employee_id}
                                            className={`w-100 noWrap btn btn-info btn-label waves-effect waves-light`}>
                                            <i className=" ri-filter-3-fill label-icon align-middle fs-16 me-2" />
                                            Filter
                                        </button>
                                        </div>
                                        <div className='col-md-6'>
                                        <div>
                                            <label>Show All</label>
                                        </div>
                                        <button
                                            type="button"
                                            disabled={!this.state.location_id && !this.state.department_id && !this.state.location_shift_id && !this.state.reporting_manager_employee_id}
                                            className={`btn noWrap btn-secondary btn-label waves-effect waves-light`}
                                            onClick={this.handleClearAll}
                                        >
                                            <i className=" ri-database-2-line  label-icon align-middle fs-16 me-2"></i> Show All</button>
                                        </div>
                                    </div>
                                    </div> */}
                                     {this.state.decodedData?.includes(2) &&(
                                    <div style={{ width:"7rem"}} className=''>
                                        <div>
                                            <label className=" noWrap">Create Goals</label>
                                        </div>
                                        {this.state.decodedData?.includes(2) &&  (
                                        // <button
                                        //     type="button"
                                        //     onClick={()=>{ this.setState({  goalsModal:true, goal_title:"", goal_description:"", postLoading:false, }); }}
                                        //     className={`btn noWrap btn-primary btn-label waves-effect waves-light`}>
                                        //     <i className="ri-menu-add-fill label-icon align-middle fs-16 ms-2" />
                                        //     Add
                                        // </button>
                                        <SubmitButton otherClasses='w-100 noWrap' onClick={()=>{ this.setState({  goalsModal:true, goal_title:"", goal_description:"", postLoading:false, }); }} 
                                        // disabled={this.state.rows.length === 0}
                                        buttonName={"Add"}  type='primary' icon='ri-menu-add-fill' />
                                      )}
                                        </div>)}
                                {/* </div> */}
                                </div>
                            </div>
                            
                            <div className="card-body">
                                <div style={{ "maxHeight": "65vh", "overflowY": "auto", "overflowX": "auto" }}>
                                    <table className=" position-relative table table-borderless table-hover align-middle mb-0 table-bordered table-stripped">
                                      <thead className='bg-primary text-light bg-gradient sticky-top z-1'>
                                          <tr>
                                          <th style={{ width:"10%"}} className="text-center">Sr.No.</th>
                                          <th className="noWrap">Goal Title</th>
                                          {this.state.decodedData?.includes(3) && (
                                          <th  style={{ width:"10%"}} className="text-center">Status</th>
                                          )}
                                          {(this.state.decodedData?.includes(3) || this.state.decodedData.includes(4))&&(
                                          <th  style={{ width:"10%"}} className="text-center">Action</th> )}
                                                                                                                        {/* <th  style={{ width:"10%"}} className="text-center">Action</th> */}
                                          </tr>
                                      </thead>
                                      {this.state.rows.length === 0 ? (
                                        <tbody>
                                          <tr>
                                              <td colSpan={11}>
                                              <NoRecords />
                                              </td>
                                          </tr>
                                        </tbody>
                                      ) :
                                        <tbody>
                                        {this.state.rows.map((row,idx) => {
                                            return (
                                                <tr key={row?.goal_id}>
                                                    <td className="text-center">{idx+1}</td>
                                                    <td>{row.goal_title}</td>  

                                                  {(this.state.decodedData?.includes(3) && (
                                                    <td>
                                                        <div className="d-flex justify-content-around gap-2">
                                                            <ToggleSwitch isActive={row?.activated == 1 ? true : false} isExtFunc={true} onToggle={() => { this.handleToggleSwitch(row.goal_id, row?.activated == 1 ? false : true) }} />
                                                        </div>
                                                    </td>))}
                                                    
                                                    {(this.state.decodedData?.includes(3) || this.state.decodedData.includes(4))&&(
                                                    <td>
                                                        <div className="d-flex justify-content-around gap-2">
                                                        { this.state.decodedData?.includes(3) && ( 
                                                            <TooltipComponent name="Edit" position="bottom">
                                                            
                                                                <button
                                                                    onClick={() =>{
                                                                        this.getInfo(row);
                                                                    }}
                                                                    type="button"
                                                                    className="btn-icon btn btn-sm btn-outline-primary mr-2 text-center"
                                                                    > 
                                                                    <i className="ri-edit-box-line"></i>
                                                                </button>
                                                            
                                                            </TooltipComponent>
                                                        
                                                                  )}
                                                                  { this.state.decodedData?.includes(4) && ( 
                                                            <TooltipComponent name="Delete" position="bottom-left">
                                                            
                                                                <button onClick={() => this.handleDelete(row.goal_id)} 
                                                                className="btn-icon btn btn-sm btn-outline-danger">
                                                                    <i className="ri-delete-bin-line"></i> 
                                                                </button>
                                                            </TooltipComponent>)}
                                                        </div>
                                                        
                                                    </td> )}
                                                      
                                                </tr>
                                            );
                                        })}
                                        </tbody>
                                      }
                                    </table>
                                </div>
                                <div className="d-flex justify-content-between bg-light align-items-center flex-wrap w-100 py-2 px-2">
                                  <SubmitButton onClick={()=>{ this.handlePrev() }} 
                                  disabled={this.state.prev === false && this.state.loadingList === false}
                                  buttonName={"Previous"}  type='warning' icon='ri-arrow-left-line' />
                                  <SubmitButton otherClasses='d-md-none d-block' iconSide='right' onClick={()=>{ this.handleNext() }} 
                                  disabled={this.state.next === false && this.state.loadingList === false}
                                  buttonName={"Next"}  type='primary' icon='ri-arrow-right-line' />
                                        <div className="col-md-4 col-12 my-md-0 my-2" style={{ display: "flex", alignItems: "center" }}>
                                            {
                                            <small>
                                                Total Records: {this.state.total_records} |
                                                Total Pages: {this.state.total_pages} |
                                                Current Page: {this.state.page}
                                            </small>
                                            }
                                        </div>
                                        <div className="col-md-2">
                                            <select className="form-select" onChange={(e) => this.handleChange(e)}>
                                            {Array.from(
                                                { length: this.state.total_pages },
                                                (_, i) => (
                                                <option selected={this.state.page === i + 1} key={i} value={i + 1}>
                                                    Page {i + 1}
                                                </option>
                                                )
                                            )}
                                            </select>
                                        </div>
                                        <div className="col-md-2">
                                            <select className="form-select" onChange={this.handleLimitChange} value={this.state.limit}>
                                                {this.state.rows?.length>0 && (
                                                    <option value={this.state.rows?.length}>
                                                      All
                                                    </option>
                                                )}
                                                {limitOptions.map((option) => (
                                                    <option key={option} value={option}>
                                                    Limit {option}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        {/* <button
                                            disabled={
                                            this.state.next === false &&
                                                this.state.loadingList === false
                                                ? true
                                                : false
                                            }
                                            type="button"
                                            onClick={() => this.handleNext()}
                                            className={`btn btn-primary btn-label waves-effect right waves-light`}
                                        >
                                            <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                                            Next
                                        </button> */}
                                        <SubmitButton otherClasses='d-md-block d-none' iconSide='right' onClick={()=>{ this.handleNext() }} 
                                        disabled={this.state.next === false && this.state.loadingList === false}
                                        buttonName={"Next"}  type='primary' icon='ri-arrow-right-line' />
                                </div>
                            </div>
                            </div>
                            {this.state.goalsModal && (
                                <div className="modal show"  style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)",}} >
                                    <div className=" m-auto mt-4 w-modal">
                                        <div className="modal-content">
                                        <div className="modal-header pb-0">
                                            <h5 className="modal-title" id="exampleModalgridLabel">{this.state.company_user_id? "Update" : "Create"} Goals</h5>
                                            <button type="button" disabled={this.state.postLoading} className="btn-close" onClick={()=>{
                                            this.setState({ goal_id:'', goalsModal:false, goal_title:"", goal_description:"",})}} aria-label="Close" />
                                        </div>
                                        <div className="modal-body pt-0">
                                            <div className="container mt-2">
                                            <form className="row">
                                                <div className="col-md-12 mt-3">
                                                    <label htmlFor="goal_title" className="form-label">Goal Title</label>
                                                    <input
                                                        type="text"
                                                        className={`form-control ${this.state.errors.goal_title ? 'is-invalid' : ''}`}
                                                        id="goal_title"
                                                        name="goal_title"
                                                        value={this.state.goal_title}
                                                        onChange={(e) => this.handleInputChange(e)}
                                                        placeholder="Enter Title"
                                                    />
                                                    {this.state.errors.goal_title && <div className="text-danger">{this.state.errors.goal_title}</div>}
                                                </div>
                                                <div className="col-md-12 mt-3">
                                                    <label htmlFor="goal_description" className="form-label">Goal Descrisption</label>
                                                    <textarea 
                                                        className={`form-control ${this.state.errors.goal_description ? 'is-invalid' : ''}`}
                                                        id="goal_description"
                                                        name="goal_description"
                                                        value={this.state.goal_description}
                                                        onChange={(e) => this.handleInputChange(e)}
                                                        placeholder="Write Description..."
                                                    />
                                                    {this.state.errors.goal_description && <div className="text-danger">{this.state.errors.goal_description}</div>}
                                                </div>
                                                
                                            </form>
                                            {this.state.decodedData?.includes(3) && (
                                            <div className="col-md-12" style={{ marginTop: "30px" }}>
                                                    {!this.state.postLoading ? 
                                                            <button
                                                            disabled={!this.state.goal_title || !this.state.goal_description}
                                                            className={`btn noWrap btn-primary btn-label waves-effect waves-light `}
                                                            onClick={()=>{
                                                                if(!this.state.postLoading){
                                                                    this.setState({postLoading:true},
                                                                        ()=>{
                                                                            this.handleSubmit()
                                                                        }
                                                                    );
                                                                    
                                                                }
                                                            }}
                                                            >
                                                                <i className={`ri-save-line label-icon align-middle fs-16`} />{ this.state.goal_id?"Update" : "Save"}
                                                            </button> :
                                                            <button className="btn btn-primary btn-load">
                                                                <span className="d-flex align-items-center">
                                                                    <span className="spinner-border flex-shrink-0" role="status">
                                                                        <span className="visually-hidden">Loading...</span>
                                                                    </span>
                                                                    <span className="flex-grow-1 ms-2">
                                                                        Processing...
                                                                    </span>
                                                                </span>
                                                            </button>
                                                        }
                                                </div>
                                            )}
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                        </div>
                    </div>
                </div>
            </div>:
            <div className='d-flex justify-content-center align-items-center' style={{ height: "90vh" }}>
            <div className="text-center">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
          </div>
        }
        </>
    );
  }
}
export default withRouter(CreatePmsTask);
